import {pipeHandlers} from 'utils/reduxEffects';
import sales from './salesPage/handler';

export default pipeHandlers(sales);
